import { createReducer } from '@reduxjs/toolkit';

import postOrderedPartType, { clearPostOrderedPartTypeData } from '../../thunks/general/postOrderedPartType';

const initialState = {
  loading: false,
  error: '',
  data: null,
};

const postOrderedPartsTypeReducer = createReducer(initialState, {
  [postOrderedPartType.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [postOrderedPartType.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [clearPostOrderedPartTypeData]: () => initialState,
  [postOrderedPartType.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default postOrderedPartsTypeReducer;
